/**
 * Turn ratings (workspace docs/guardian/03 §1.4, audit P-10; 2026-10-21).
 *
 * The agent's `done` frame carries the turn's `record_id`. It is attached to
 * the turn's answer (the last assistant message after the last user message,
 * the same rule as tool evidence), so the thumbs on that answer rate it.
 * Only a well-formed UUID is accepted: the frame is external input.
 */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isRecordId(value) {
  return typeof value === 'string' && UUID_RE.test(value);
}

export function attachRecordIdToAnswer(messages, recordId) {
  if (!isRecordId(recordId)) return messages;
  let lastUser = -1;
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    if (messages[i].type === 'user') {
      lastUser = i;
      break;
    }
  }
  for (let i = messages.length - 1; i > lastUser; i -= 1) {
    const m = messages[i];
    if (m.type === 'assistant') {
      if (m.recordId) return messages;
      const next = messages.slice();
      next[i] = { ...m, recordId: recordId.toLowerCase() };
      return next;
    }
  }
  return messages;
}

/** Sets (1 / -1) or clears (0 -> null) the rating on one message by id. */
export function setMessageRating(messages, messageId, value) {
  let changed = false;
  const next = messages.map((m) => {
    if (m.id !== messageId) return m;
    changed = true;
    return { ...m, rating: value === 0 ? null : value };
  });
  return changed ? next : messages;
}
